import { BASE_URL } from "../../Environment/config"
import { httpClient } from "../../Http/client";

export const loginUser = async (data) => {
    const url = `${BASE_URL}/login`;

    const { data: loginData} = await httpClient.post(url, data);
    return loginData;
}